<template>
	<div class="c-app">
		<modal-session-inactive
			v-if="isIdle"
			:trigger-modal="true"
			@refresh="showIdleModal = false"
		/>
		<TheSidebar />
		<CWrapper>
			<TheHeader />
			<div class="c-body">
				<main class="c-main">
					<CContainer fluid>
						<transition name="fade">
							<router-view></router-view>
						</transition>
					</CContainer>
				</main>
				<TheFooter />
			</div>
		</CWrapper>
	</div>
</template>

<script>
	import TheSidebar from './TheSidebar';
	import TheHeader from './TheHeader';
	import TheFooter from './TheFooter';
	import modalSessionInactive from '../components/modals/modalSessionInactive';

	export default {
		name: 'TheContainer',
		components: {
			TheSidebar,
			TheHeader,
			TheFooter,
			modalSessionInactive
		},
		data() {
			return {
				userTokens: null,
				delaySeconds: 10,
				showIdleModal:false
			};
		},
		created() {
			this.getUserTokens;
		},
		methods: {},
		computed: {
			getUserTokens: function() {
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				return (this.userTokens = JSON.parse(
					sessionStorage.getItem('userTokens')
				));
			},
			isIdle() {
				let test = false
				if (this.$store.state.idleVue.isIdle && !this.showIdleModal) {
					// eslint-disable-next-line vue/no-side-effects-in-computed-properties
					this.showIdleModal = true;
					test = true;
				}else if (!this.$store.state.idleVue.isIdle && this.showIdleModal) {
					test = true;
				}
				return test;
			}
		},
		watch: {},
	};
</script>

<style scoped>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}
	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
</style>
